import React from 'react';
import { View } from 'react-native-web';
import PhoneHeadLine from '../FullPagesComponents/PhoneHeadLine';

//= ========================================================================

const TopBarComponent = ({
  globJSON,
  simPlatform,
  headlineText,
  isMenu,
  hidePhoneHeadLine,
  hideArrow,
  hideTitle,
  hideCloseButton,
  hideGreyLine,
  withCheckIconOnTop,
  withOutPadding,
  withGrayCircle,
}) => {
  const { colors } = globJSON.configurations.theme;

  const myStyles = {
    column: {
      flexDirection: 'column',
      paddingTop: 3,
      backgroundColor: isMenu && colors.menu_top_area_color,
    },
    greyLine: {
      width: 23,
      height: 3,
      alignSelf: 'center',
      marginBottom: hidePhoneHeadLine ? 0 : 4,
      borderRadius: 1.5,
      backgroundColor: colors.tertiary_icons_color,
    },
  };

  return (
    <View style={myStyles.column}>
      {!hideGreyLine && <View style={myStyles.greyLine} />}
      {!hidePhoneHeadLine && (
        <PhoneHeadLine
          globJSON={globJSON}
          simPlatform={simPlatform}
          headlineText={headlineText}
          isMenu={isMenu}
          hideIcons={hidePhoneHeadLine}
          hideArrow={hideArrow}
          hideTitle={hideTitle}
          hideCloseButton={hideCloseButton}
          hideGreyLine={hideGreyLine}
          withOutPadding={withOutPadding}
          withCheckIconOnTop={withCheckIconOnTop}
          withGrayCircle={withGrayCircle}
        />
      )}
    </View>
  );
};
export default TopBarComponent;
